import * as React from "react";
import { Box, Typography } from "@mui/material";

export interface CclSearchDefaultProps {
    line1: string;
    line2: string;
    backgroundImageUrl?: string;
    hasButtons?: boolean;
    hideOr?: boolean;
    children?: React.ReactNode;
}

export const CclSearchDefault: React.FC<CclSearchDefaultProps> = (props) => {
    const hasBackgroundImage = props.backgroundImageUrl && props.backgroundImageUrl.trim() !== "";
    return (
        <>
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backgroundImage: hasBackgroundImage
                        ? `url(${props.backgroundImageUrl})`
                        : undefined,
                    backgroundSize: hasBackgroundImage ? "cover" : undefined,
                    backgroundPosition: hasBackgroundImage ? "center" : undefined,
                    opacity: 0.5,
                    zIndex: 0,
                }}
            />{" "}
            <Box
                sx={{
                    position: "relative",
                    zIndex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                }}
            >
                <Box
                    sx={{
                        width: "fit-content",
                        backgroundColor: "#f5f5f5", // MUI default background
                        borderRadius: 4,
                        boxShadow: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        opacity: 0.75,
                        p: 5,
                        m: "auto",
                    }}
                >
                    <Typography variant="h5">{props.line1}</Typography>
                    <Typography variant="h6">{props.line2}</Typography>
                    {props.hasButtons && props.children ? (
                        <React.Fragment>
                            {!props.hideOr && (
                                <Typography variant="h6" sx={{ marginTop: "4px", marginBottom: "4px" }}>
                                    OR
                                </Typography>
                            )}
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                gap={3}
                                sx={{ width: 1 }}
                            >
                                {props.children}
                            </Box>
                        </React.Fragment>
                    ) : null}
                </Box>
            </Box>
        </>
    );
};

export default CclSearchDefault;
